export default __webpack_public_path__ + "static/media/contact-dark.5c2b414d.svg";